import { icons } from '@boltenergy-be/design-system/dist/components/icon/icons'

export const SOCIALS: Record<string, { url: string; icon: keyof typeof icons }> = {
  facebook: {
    url: 'https://www.facebook.com/boltenergie',
    icon: 'facebook'
  },
  instagram: {
    url: 'https://www.instagram.com/boltenergie',
    icon: 'instagram'
  },
  linkedin: {
    url: 'https://www.linkedin.com/company/bolt-energie',
    icon: 'linkedinSquare'
  }
}
